export default "<span class=\"ysh-pill-button-wrapper\"><ng-content></ng-content></span>\n";